module.exports = "/assets/data/0d22a02a8cb85ecbf71c2d8b26f83625-SO43.data.json";